module.exports = __webpack_public_path__ + "nc_static/media/in-progress.a7f339ea.svg";